import { call, put, takeEvery, all } from 'redux-saga/effects';
import { Routine } from 'redux-saga-routines';
import {
  fetchPositionRoutine,
  fetchPositionCountersRoutine,
  fetchCandidatesByPositionIdRoutine,
  checkPositionNameRoutine, setNewPositionNameRoutine
} from '../routines';
import {
  checkPositionName,
  getPositionById,
  getPositionCountersById,
  updatePosition
} from '../../../services/positionService';
import { getCandidatesByPositionId } from '../../../services/candidateService';

function* getPositionByIdRequest({ payload }: Routine<any>) {
  try {
    const response = yield call(getPositionById, payload);

    yield put(fetchPositionRoutine.success(response));
  } catch {
    yield put(fetchPositionRoutine.failure());
  }
}

function* getPositionCountersByIdRequest({ payload }: Routine<any>) {
  try {
    const response = yield call(getPositionCountersById, payload);

    yield put(fetchPositionCountersRoutine.success(response));
  } catch {
    yield put(fetchPositionCountersRoutine.failure());
  }
}

function* getCandidatesByPositionIdRequest({ payload }: Routine<any>) {
  try {
    const response = yield call(getCandidatesByPositionId, payload);
    const data = {
      ...response,
      reset: !payload.from
    };
    yield put(fetchCandidatesByPositionIdRoutine.success(data));
  } catch {
    yield put(fetchCandidatesByPositionIdRoutine.failure());
  }
}

function* checkPositionNameRequest({ payload }: Routine<any>) {
  try {
    const { isNameTaken } = yield call(checkPositionName, { name: payload.name, ids: [payload.id] });
    yield put(checkPositionNameRoutine.success({ isNameTaken }));
  } catch (error) {
    yield put(checkPositionNameRoutine.failure(error.message));
  }
}

function* setNewPositionNameRequest({ payload }: Routine<any>) {
  try {
    yield call(updatePosition, { name: payload.name, id: payload.id });
    yield put(setNewPositionNameRoutine.success());
  } catch (error) {
    yield put(setNewPositionNameRoutine.failure(error.message));
  }
}

function* watchGetPositionByIdRequest() {
  yield takeEvery(fetchPositionRoutine.TRIGGER, getPositionByIdRequest);
}

function* watchGetPositionCountersByIdRequest() {
  yield takeEvery(fetchPositionCountersRoutine.TRIGGER, getPositionCountersByIdRequest);
}

function* watchGetCandidatesByPositionIdRequest() {
  yield takeEvery(fetchCandidatesByPositionIdRoutine.TRIGGER, getCandidatesByPositionIdRequest);
}

function* watchCheckPositionNameRequest() {
  yield takeEvery(checkPositionNameRoutine.TRIGGER, checkPositionNameRequest);
}

function* watchNewPositionNameRequest() {
  yield takeEvery(setNewPositionNameRoutine.TRIGGER, setNewPositionNameRequest);
}

export default function* positionProfileSaga() {
  yield all([
    watchGetPositionByIdRequest(),
    watchGetPositionCountersByIdRequest(),
    watchGetCandidatesByPositionIdRequest(),
    watchCheckPositionNameRequest(),
    watchNewPositionNameRequest()
  ]);
}
